<div class="flex flex-col gap-4">
  <p-card header="Dane wniosku" class="custom-card">
    <div class="grid grid-cols-1 gap-4 p-4">
      <app-preview-data-wrapper
        [data]="application().typDokumentu?.nazwa"
        additionalCssClasses="font-bold"
        label="Nazwa typu wniosku"
      />
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 xl:grid-cols-3 gap-4 p-4">
      <app-preview-data-wrapper
        [data]="application().typDokumentu?.kod"
        additionalCssClasses="font-bold"
        label="Kod typu wniosku"
      />
      <app-preview-data-wrapper
        [data]="application().wersjaWzoru"
        additionalCssClasses="font-bold"
        label="Wersja wzoru wniosku"
      />
      <app-preview-data-wrapper
        [data]="application().wersjaFormularza"
        additionalCssClasses="font-bold"
        label="Wersja formularza"
      />
      <app-preview-data-wrapper
        [dataType]="PreviewDataType.DATE_TIME"
        additionalCssClasses="font-bold"
        [data]="application().dataUtworzenia"
        label="Czas utworzenia"
      />
      <app-preview-data-wrapper
        [dataType]="PreviewDataType.DATE_TIME"
        additionalCssClasses="font-bold"
        [data]="application().dataWplywu"
        label="Czas wysłania"
      />
      <app-preview-data-wrapper
        [data]="application().adresat"
        additionalCssClasses="font-bold"
        label="Adresat"
      />
    </div>
  </p-card>

  @if (application().typDokumentu?.kod | isTypDokumentuZus) {
    <p-card class="custom-card">
      <strong>Informacja</strong>
      <br />
      Po wysłaniu wniosku do ZUS system nie przechowuje informacji o treści i
      załącznikach.
      <br />
      Wniosek wraz z załącznikami będzie dostępny na eZUS.
    </p-card>
  } @else {
    <p-card header="Załączniki – dokumenty elektroniczne" class="custom-card">
      @if (!relatedDocuments().length) {
        <div class="p-4 text-gray-500 italic text-center">
          Brak dodatkowych dokumentów.
        </div>
      } @else {
        <div class="wide">
          <p-table
            [value]="relatedDocuments()"
            [paginator]="true"
            [rows]="5"
            [rowsPerPageOptions]="[5, 10, 25]"
            [tableStyle]="{ 'min-width': '50rem' }"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Kod dokumentu</th>
                <th>Nazwa dokumentu</th>
                <th>Akcje</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-doc>
              <tr>
                <td>{{ doc.typDokumentu?.kod }}</td>
                <td>{{ doc.typDokumentu?.nazwa }}</td>
                <td class="text-center">
                  <p-button
                    type="button"
                    (click)="exportRelatedApplication(doc.id)"
                    ariaLabel="Pobierz"
                    pTooltip="Pobierz"
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                  >
                    <i class="pi pi-download icon" aria-hidden="true"></i>
                  </p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </p-card>
  }
  <p-card header="Załączniki – dołączone pliki" class="custom-card">
    @if (!application().zalaczniki?.length) {
      <div class="p-4 text-center text-gray-500 italic">
        Brak dodatkowych załączników.
      </div>
    } @else {
      <div class="wide">
        <p-table
          [value]="application().zalaczniki ?? []"
          [paginator]="false"
          [tableStyle]="{ 'min-width': '50rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 25%">Nazwa</th>
              <th style="width: 25%">Czas utworzenia</th>
              <th style="width: 25%">Akcje</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-attachment>
            <tr>
              <td>{{ attachment.nazwa }}</td>
              <td>
                {{ attachment.dataUtworzenia | date: 'yyyy-MM-dd HH:mm:ss' }}
              </td>
              <td>
                <div class="flex gap-4">
                  <p-button
                    type="button"
                    (click)="downloadAttachment(attachment)"
                    ariaLabel="Pobierz"
                    pTooltip="Pobierz"
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                  >
                    <i class="pi pi-download icon" aria-hidden="true"></i>
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </p-card>

  @if (!(application().typDokumentu?.kod | isTypDokumentuZus)) {
    <div class="flex mt-4 gap-2 flex-wrap">
      <p-button
        styleClass="customInfoButton outlined"
        size="small"
        [label]="isArchived() ? 'Cofnij archiwizację' : 'Archiwizuj'"
        (click)="
          isArchived()
            ? restoreFromArchiveDocumentDialog()
            : archiveDocumentDialog()
        "
      />
      <p-button
        styleClass="customInfoButton outlined"
        size="small"
        label="Podgląd wniosku"
        (click)="showApplicationVisualization()"
      />
      <p-button
        styleClass="customInfoButton outlined"
        size="small"
        label="Eksportuj"
        (click)="exportApplication()"
      />
      @if (!isOrganizationContext()) {
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          [label]="'Przenieś wniosek na konto organizacji'"
          [disabled]="!(application() | isMoveToOrganizationActive)"
          (click)="openMoveToOrganizationDialog()"
        />
      }
      @if (application() | shouldShowCorrespondenceIcon: inboxType()) {
        <p-button
          styleClass="customInfoButton outlined"
          size="small"
          (click)="correspondRegardingApplication(application())"
          label="Koresponduj w sprawie"
        />
      }
      <p-button
        styleClass="customInfoButton outlined"
        size="small"
        label="Status poświadczenia odbioru"
        (click)="
          showPoswiadczenieStatus(application().poswiadczenie, application().id)
        "
      />
    </div>
  }
</div>
